import {FieldEvent} from './settings';
import {List} from '../../common/fields/list';
import {fieldArts as arts} from '../../artjs/field';
import {Checkbox} from '../../common/fields/checkbox';
import {Select} from '../../common/fields/select';

export function createLIST(d) {
  switch (parseInt(d.displayType, 10)) {
    case 5:
    case 6:
      FieldEvent[d.fieldName] = new Checkbox(d);
      break;
    case 4:
      FieldEvent[d.fieldName] = new Select(d);
      break;
    default:
      FieldEvent[d.fieldName] = new List(d);
  }
  return FieldEvent[d.fieldName];
}

export function renderLIST(d) {
  const field = FieldEvent[d];
  if (!field.dom) {
    field.dom = document.getElementById(`sk-field-${d}`);
  }
  let s = null;
  if (field.dom) {
    const ss = {3: 'FIELDRADIO', 4: 'FIELDSELECT', 5: 'FIELDCHECKBOX', 6: 'FIELDCHECKBOXSELECT'};
    s = ss[field.displayType];
    field.dom.innerHTML = arts[s].pc({field: field});
  }
}

export function changeLIST(v, d) {
  const field = FieldEvent[d];
  const o = field.listOptions.filter(b => {
    return b.optionId == v;
  })[0];
  field.setValue(o);
  renderLIST(d);
}

export function clickLIST(v, d, i) {
  const field = FieldEvent[d];
  let o = field.listOptions.filter(b => {
    return b.optionId == v;
  })[0];
  if (field.isCascade == 1) {
    o = field.listOptions[i].filter(b => {
      return b.optionId == v;
    })[0];
    field.setManyValue(o);
  } else {
    field.setValue(o);
  }
  renderLIST(d);
}

export function clickListFocus(ev, o, d) {
  ev.stopPropagation();
  const field = FieldEvent[d];
  field.setValue(o);
}

export function changeCHECKBOX(e, v, d) {
  const field = FieldEvent[d];
  const o = field.listOptions.filter(b => {
    return b.optionId == v;
  })[0];
  field.setValue(o, e.checked);
  renderLIST(d);
}

export function changeListOtherValue(e, o, d) {
  const field = FieldEvent[d];
  field.setOtherValue(o, e.value);
  renderLIST(d);
}

